@if (ticketStatusChange(); as ticketStatusChange) {
  @let createdByUser = ticketStatusChange?.createdByUser;
  @let createdByContact = ticketStatusChange.createdByContact;
  <div [class.table-style]="tableStyle()" class="work-ui-timeline__item">
    <div class="work-ui-timeline__item-badge">
      <div class="work-ui-timeline__item-badge-icon"></div>
    </div>
    <div class="work-ui-timeline__item-body">
      <div class="work-ui-timeline__item__meta flex gap-48 space-between margin-bottom-4" style="height: 40px">
        <div class="flex flex-row vertical-center gap-8">
          @if (createdByUser) {
            <work-ui-avatar
              [imgSrc]="createdByUser && createdByUser.userImage ? (createdByUser.userImage.fileSrcThumbnail | prependServerToFileSrc) : null"
              [size]="'mini'" />
          }
          <div class="flex flex-column gap-2">
            <div>
              <small
                class="work-text-color-light work-text-size-micro">{{ ticketStatusChange.created | formatDate: 'DD.MM.YYYY, HH:mm [Uhr]' }}</small>
            </div>
            <p class="flex flex-row vertical-center gap-4 wrap">
              @if (createdByUser) {
                <a
                  [routerLink]="'/mitarbeiter/details/' + ticketStatusChange?.createdByUserId"><b>{{ createdByUser.firstName }} {{ createdByUser.lastName }}</b></a>@if (!tableStyle()) {
                  {{ 'TICKET_STATUS_GEAENDERT_PREFIX' | translate }}
                }
              } @else if (createdByContact) {
                <a
                  [routerLink]="'/kontakte/details/' + ticketStatusChange.createdByContactId"><b>{{ createdByContact.firstName }} {{ createdByContact.lastName }}</b></a>@if (!tableStyle()) {
                  {{ 'TICKET_STATUS_GEAENDERT_PREFIX' | translate }}
                }
              }
              @if (!tableStyle() && ticketStatusChange.status) {
                <work-ui-badge [text]="ticketStatusChange.status.name + ''"
                               [variant]="ticketStatusChange.statusId | getTicketStatusColorVariant"
                               size="small" />
              }
              @if (createdByUser || createdByContact) {
                {{ 'TICKET_STATUS_GEAENDERT_SUFFIX' | translate }}
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
}
